// The canonical clinic order — ported from ../../src/locations.js.
//
// PORTED, NOT RE-DERIVED: this must stay byte-for-byte in sync with the
// server's copy, which is why the same LOCATION_ORDER array is reproduced
// here verbatim rather than re-sorted some other way. The whole point of
// finding F-9 was that a surface deriving its own order is how the tab-order
// bug happened; the client must not invent a second source, so it imports
// the one constant instead of computing an order.
//
// decisions/LOG.md, 2026-08-12, Tomer verbatim: "whenever the four locations
// appear together ... the order is ALWAYS: Lake Mary, The Villages, Winter
// Garden, Winter Park (left to right). That's MELM, MEVL, MEWG, MEWP."
//
// SPEC-001 §13, enforced by INV-14.

export const LOCATION_ORDER = ['MELM', 'MEVL', 'MEWG', 'MEWP'] as const;

export type LocationCode = (typeof LOCATION_ORDER)[number];

export const LOCATION_NAMES: Record<LocationCode, string> = {
  MELM: 'Lake Mary',
  MEVL: 'The Villages',
  MEWG: 'Winter Garden',
  MEWP: 'Winter Park',
};

/**
 * Sort location codes into canonical order. A code not in the canonical list
 * sorts last rather than being dropped (same discipline as position
 * bucketing — an unrecognised value stays visible instead of disappearing).
 *
 * This is the ONLY function in this app allowed to determine clinic order.
 * No page may sort locations itself.
 */
export function orderLocations<T extends string>(codes: readonly T[]): T[] {
  const rank = (code: T) => {
    const i = LOCATION_ORDER.indexOf(code as unknown as LocationCode);
    return i === -1 ? LOCATION_ORDER.length : i;
  };
  return [...codes].sort((a, b) => rank(a) - rank(b) || String(a).localeCompare(String(b)));
}
